import { useSystemStore } from '../stores/SystemStore';
import { useUserStore } from '../stores/UserStore';
import type { RouterOutput } from '../utils/trcp';
import { trcpProxyClient } from '../utils/trcp';

interface Response {
	data?: RouterOutput['user']['getGroupSettings'];
	refetch: () => Promise<RouterOutput['user']['getGroupSettings']>;
}

export const useGroupSettings = (): Response => {
	const groupSettings = useUserStore(state => state.groupSettings);
	const setGroupSettings = useUserStore(state => state.setGroupSettings);

	const refetch = async () => {
		const data = await trcpProxyClient.user.getGroupSettings.query({
			schoolId: useSystemStore.getState().activeSchoolId,
		});

		setGroupSettings(data);

		return data;
	};

	return { data: groupSettings, refetch };
};
